import { Link } from "react-router-dom";
import { submitSteps } from "@/mocks/site";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

export default function SubmitProcessSection() {
  return (
    <section className="border-y border-background-200 bg-secondary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-6 md:py-20 lg:px-10">
        <div className="max-w-2xl">
          <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-primary-300">
            <span className="h-px w-6 bg-primary-400" />
            HOW TO SUBMIT
          </p>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-background-50 md:text-[32px] md:leading-[1.25]">
            从一条线索到一篇上墙稿件，只走四步
          </h2>
          <p className="mt-3 text-sm leading-7 text-background-300 md:text-[15px]">
            整个流程里，没有任何一步需要你暴露真实身份。你可以只写一段话，也可以附上整理好的完整材料。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {submitSteps.map((step, index) => (
            <Reveal key={step.seq} delay={index * 90}>
              <div className="flex h-full flex-col rounded-lg border border-secondary-800 bg-secondary-900/60 p-6">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-3xl font-bold text-secondary-700">{step.seq}</span>
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-xl text-background-50">
                    <i className={step.icon} aria-hidden="true" />
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-background-50">{step.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-7 text-background-300">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start gap-5 rounded-lg border border-secondary-800 bg-secondary-900/40 p-7 md:flex-row md:items-center md:justify-between">
          <div>
            <h3 className="font-heading text-xl font-bold text-background-50">稿件还在犹豫要不要投？</h3>
            <p className="mt-2 max-w-xl text-sm leading-7 text-background-300">
              可以先只提交一段描述，我们在核实阶段再和你确认细节。撤回、修改都在你手上。
            </p>
          </div>
          <Link
            to="/submit"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            <i className="ri-send-plane-line text-base" aria-hidden="true" />
            前往投稿入口
          </Link>
        </div>
      </div>
    </section>
  );
}